export var pluralize = function (singular, plural, quantity) {
    if (quantity === 1) {
        return singular;
    }
    return plural;
};
